import { BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, DisabledPrompt, Link, StateManager, useBCMSContext, useRoute, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import AddCardWrapper from "components/shared/containers/AddCardWrapper";
import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import UITextInput from "components/ui/UITextInput";
import Classes, { Card } from "model";
import React from "react";

import "./styles.css";

/**
 * @function UserVerificationPage
 * @return {React.Component}
 * @exported true
 * @description The main component for UserVerificationPage
 */

export default function UserVerificationPage(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);
  const defaultData = getDefaultData(context);
  const { goStep, state } = useWorkflow() ?? {};
  const navigate = useRoute();
  const data = { ...getDefaultData(context), ...state, ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    update: (obj, prop) => val => {
      const crud = BCMSStateManagerCRUD.init(state);
      if(obj && prop) {
        crud.update([ "data", obj, prop ], val);
      } else {
        crud.update([ "data", prop ], val);
      }
      crud.submit(setState);
    },

    goToUserVerificationPage: () => {
      goStep(2, { data, ui });
    },

    cancel: () => {
      data.card.number = "";
      goStep(0, { data, ui });
    },

    next: () => {
      goStep(3, { data, ui });
    },
  });

  return (
    <StateManager state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </StateManager>
  );
}

export const getDefaultData = controller => {
  const branding = controller.state.branding;
  const options = controller.state.branding.options;
  const card = options.include_debit_chw23 === "false"
      ? BCMSDefaultModel.creditCard()
      : BCMSDefaultModel.debitCard();
  card.number = "";
  card.expDatePlaceholder = "";
  card.id = Card.nextID();

  if(options.activate_card_chw23 === "false") {
      card.active = true;
  }

  return { 
    card,
    branding,
    accessCode: ""
  };
}

export const getDefaultUI = () => {

}

function PageContent(props) {
  const { data, update, cancel, next, goToUserVerificationPage } = useStateManager();
  //const workflowStep = useWorkflowStep(getDefaultCard, getWorkflowSteps);

  /*const nextButton = evt => workflowStep.workflow.nextStep(workflowStep.getStepState);
  const cancelButton = evt => {
    const card = workflowStep.read("card");
    card.number = "";

    workflowStep.workflow.prevStep({ ...workflowStep.getStepState, card });
  };*/

  //const [ state, setState ] = useState("");
  //const update = value => setState(value);

  return (
    <AddCardWrapper className="user-verification-page">
      <MainContentContainer className="hide-chevron-icon" header={<MainContentHeader text="User Verification" />}>
        <FormContainer>
          <FormRow>
            <p>Please enter your Access Code.</p>
          </FormRow>
          <FormRow className="flex-container flex-vertical align-right-container access-code-form-row">
            <UITextInput value={ data.accessCode } onChange={ update(undefined, "accessCode") } placeholder="Enter the Access Code*" />
            <DisabledPrompt><Link className="text-right">Having trouble?</Link></DisabledPrompt>
          </FormRow>
          
          <p className="contact-us-text">If you need a new Access Code, <DisabledPrompt><Link>Contact Us.</Link></DisabledPrompt></p>

          <FormButtonContainer>
            <UIPrimaryButton text="Next" onClick={ next } />
            <UICancelButton text="Cancel" onClick={ cancel } />
          </FormButtonContainer>
        </FormContainer>
      </MainContentContainer>
    </AddCardWrapper>
  );
}